"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("BasisModal", {
    attrs: {
      title: "自定义单元格样式属性"
    },
    on: {
      ok: _vm.handleOk
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c("div", {
    staticClass: "m-tips-color m-m-b-8 m-m-l-48"
  }, [_vm._v("通过该处配置的单元格背景色和字重，将会在“智能报表”列表中展示")]), _c("a-form-model", {
    attrs: {
      model: _vm.record,
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 18
      }
    }
  }, [_c("a-form-model-item", {
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      label: "背景色",
      prop: "backgroundColor"
    }
  }, [_c("div", {
    staticClass: "m-flex"
  }, [_c("colorPicker", {
    attrs: {
      "default-color": "transparent"
    },
    model: {
      value: _vm.record.style.backgroundColor,
      callback: function ($$v) {
        _vm.$set(_vm.record.style, "backgroundColor", $$v);
      },
      expression: "record.style.backgroundColor"
    }
  }), _c("span", {
    staticClass: "m-tips-color m-m-l-8"
  }, [_vm._v("默认为透明背景")])], 1)]), _c("a-form-model-item", {
    attrs: {
      label: "字重",
      prop: "fontWeight"
    }
  }, [_c("a-radio-group", {
    model: {
      value: _vm.record.style.fontWeight,
      callback: function ($$v) {
        _vm.$set(_vm.record.style, "fontWeight", $$v);
      },
      expression: "record.style.fontWeight"
    }
  }, [_c("a-radio", {
    attrs: {
      value: "bold"
    }
  }, [_vm._v("加粗")]), _c("a-radio", {
    attrs: {
      value: "normal"
    }
  }, [_vm._v("正常")])], 1)], 1)], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;